module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/arm-details/arm-details.component.css
// module id = ./src/app/pages/functions/arm-details/arm-details.component.css
// module chunks = main